import axiosService from '../axios'

export const list = (params?: any) => {
  return axiosService({
    url: '/api.invoice',
    method: 'get',
    params,
  })
}

export const listAllByDirector = (params?: any) => {
  return axiosService({
    url: '/api.invoice/all',
    method: 'get',
    params,
  })
}

export const count = () => {
  return axiosService({
    url: `/api.invoice/count-pending`,
    method: 'get',
  })
}

export const get = (id: number) => {
  return axiosService({
    url: `/api.invoice/${id}`,
    method: 'get',
  })
}

export const update = (id: number, data: any) => {
  return axiosService({
    url: `/api.invoice/${id}`,
    method: 'put',
    data,
  })
}

export const apply = (id: number) => {
  return axiosService({
    url: `/api.invoice/${id}/apply`,
    method: 'put',
  })
}

export const reject = (id: number, data: any) => {
  return axiosService({
    url: `/api.invoice/${id}/reject`,
    method: 'put',
    data,
  })
}

export const remake = (id: number, data: any) => {
  return axiosService({
    url: `/api.invoice/${id}/remake`,
    method: 'put',
    data,
  })
}

export const approve = (id: number, data: any) => {
  return axiosService({
    url: `/api.invoice/${id}/approve`,
    method: 'put',
    data: data,
  })
}

export const pay = (id: number, data: any) => {
  return axiosService({
    url: `/api.invoice/${id}/pay`,
    method: 'put',
    data: data,
  })
}

export const destroy = (id: number) => {
  return axiosService({
    url: `/api.invoice/${id}`,
    method: 'delete',
  })
}

export const create = (data: any) => {
  return axiosService({
    url: '/api.invoice',
    method: 'post',
    data,
  })
}
